import { ApiError } from '@lib/api/api-response';

export async function fetchListingImportJob(
  importId: string
): Promise<unknown> {
  const response = await fetch(`/api/listings/import/${importId}`);
  if (!response.ok) {
    throw new ApiError('Failed to load import', response.status);
  }
  return response.json();
}
